import Vue from 'vue';

export const trackEvent = (event) => {
	if (Vue.gtm) {
		console.log('Track event', event);
		Vue.gtm.trackEvent(event);
	} else {
		console.log('Vue GTM not setup - no tracking of event', event);
	}
};

export default { trackEvent };
